import { updateSubscription } from 'app/shared/flux/actions/MarketingActions';
import constants from 'app/shared/flux/constants';
import type { MarketUpdateStatusErrorType, MarketUpdateStatusType } from 'app/shared/types/ApiResponseTypes';
import { toSubscriptionResult } from 'app/shared/utils/unsubscribeUtils';
import { logError } from '@zg-rentals/log-error';

const serverRouteWillMount = async ({ store }: { store: any }) => {
  const { dispatch } = store;
  const { query, queryString, pathname } = store.getState().router.location;
  const { email, marketUpdateId, enabled = false } = query;

  try {
    const res: MarketUpdateStatusType = await dispatch(
      updateSubscription({ email: decodeURIComponent(email), enabled, marketUpdateId }),
    );
    dispatch({
      type: constants.SET_UNSUBSCRIBE_RESULT,
      payload: { success: true, ...toSubscriptionResult(res) },
    });
  } catch (err) {
    logError({
      error: err as MarketUpdateStatusErrorType,
      errorType: 'Subscription',
      context: {
        details: 'Unsubscribe Page: Error updating subscription',
        root: 'pages/UnsubscribePage#useEffect',
        pathAttempted: pathname,
        queryAttempted: queryString,
      },
    });
    dispatch({
      type: constants.SET_UNSUBSCRIBE_RESULT,
      payload: { success: false },
    });
  }
};

export default serverRouteWillMount;
